<template>
    <li>
        <a class="element" :href="model.Url" :target="model.External ? '_blank' : ''">
            <div class="element__preview"><img :data-srcset="model.Image" :alt="model.ImageAlt" /></div>
            <div class="element__details element__details_wide">
                <div class="element__line">
                    <div class="stage" v-html="model.Tag"></div>
                    <div class="element__rating">
                        <div v-if="model.StarRating>0" v-for="i in model.StarRating" class="element__star"><img src="/public/img/star.svg" alt="" /></div>
                    </div>
                </div>
                <div class="element__title">{{model.Name}}</div>
            </div>
            <div class="element__content">{{model.ShortDescription}}</div>
        </a>
    </li>
</template>
<script>
    export default {
        props: {
            model: Object
        },
    }
</script>